import { colors } from '../../../config/theme'

export default {
  generalError: {
    height: 20,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: colors.error
  },
  field: {
    minWidth: '330px'
  },
  container: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.background
  },
  formContainer: {
    position: 'relative'
  },
  logoContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    top: '-80px',
    fontWeight: 100,
    margin: 0
  },
  checkContainer:{
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding:'20px 0 0 0'
  },
  logo: {
    width: '250px'
  },
  textContainer: {
    width: '330px',
    padding:'20px 0 0 0'
  },
  forgotLinkWrapper: {
    textAlign: 'center',
    padding:'60px 0 0 0'
  },
  forgotLink: {
    fontSize: 14,
    color: '#000'
  },
  header: {
    textTransform: 'uppercase',
    textAlign: 'center',
    padding:'20px 0 0 0'
  }
}



// WEBPACK FOOTER //
// ./src/containers/ResetPassword/ResetPasswordScreen/style.js